module.exports = __webpack_public_path__ + "img/ASAN_01.f4cea29a.png";